import { render } from "./AutoTopUp.vue?vue&type=template&id=2da3c0dd"
import script from "./AutoTopUp.vue?vue&type=script&lang=js"
export * from "./AutoTopUp.vue?vue&type=script&lang=js"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__